import { render, staticRenderFns } from "./AssignedUserList.vue?vue&type=template&id=8b53d946&scoped=true&"
import script from "./AssignedUserList.vue?vue&type=script&lang=js&"
export * from "./AssignedUserList.vue?vue&type=script&lang=js&"
import style0 from "./AssignedUserList.vue?vue&type=style&index=0&id=8b53d946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b53d946",
  null
  
)

export default component.exports